<template>
    <v-breadcrumbs :items="crumbs" class="pa-0">
        <template v-slot:item="{ item }">
            <Breadcrumb :item="item" />
        </template>
    </v-breadcrumbs>
</template>


<script>
import Breadcrumb from './Breadcrumb.vue';

export default {
    name: 'Breadcrumbs',
    props: {},
    components: {
        Breadcrumb,
    },

    data() {
        return {};
    },

    methods: {
        getDisplayname(route) {
            return route.meta?.display?.key ? this.$t(route.meta.display.key, { okey: route.meta.display.okey }) : route.meta?.displayName ?? route.name;
        },
    },

    computed: {
        crumbs() {
            //console.log(this.$route.matched);
            var list = this.$route.matched;
            var output = [];
            for (let index = 0; index < list.length; index++) {
                const x = list[index];

                output.push({
                    index: index,
                    icon: x.meta?.icon,
                    text: this.getDisplayname(x),
                    to: { name: x.name, query: this.$route.query, }, //params: this.$route.params 
                    link: true,
                    exact: true,
                });
                if (index == list.length - 1) { //always have hidden last crumb to show slash then the title
                    output[index].text = undefined
                    output[index].icon = undefined
                }
                if (x.meta?.contextMenu) {
                    //console.log('contextMenu');
                    output[index].text = undefined
                    output[index].icon = undefined
                    break;
                }
            }
            return output;
            /*
            return this.$route.matched.map((x, index) => {
                return {
                    index: index,
                    icon: x.meta?.icon,
                    text: this.getDisplayname(x),
                    to: { name: x.name, params: this.$route.params, query: this.$route.query }
                }
            });
            */
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>